<template>
  <section class="about-scantop">
    <b-container fluid class="about-scantop-wrap">
      <b-row
        class="about-scantop-inner justify-content-center align-items-center"
      >
        <b-col lg="5">
          <div class="img-wrap">
            <b-img src="@/assets/images/about/scantop.jpg" fluid />
          </div>
        </b-col>
        <b-col lg="6">
          <div class="desc-wrap">
            <IconTitle :info="titleInfo" />
            <p>
              Scan Top, established in 1991, has mastered the art of windshield
              wiper blade production for over 35 years. Based in Taiwan with
              manufacturing units in Taiwan and China, our forte lies in
              delivering top-notch products, speedy service, and competitive
              pricing, fueled by 100+ patented technologies.
            </p>
            <p>
              Globally recognized and trusted, Scan Top is eager to explore
              collaborative opportunities. Let's drive into a promising future
              together.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import IconTitle from "@/components/IconTitle";

export default {
  components: { IconTitle },
  data() {
    return {
      titleInfo: {
        title: "ABOUT US",
        src: require("@/assets/images/about/scantop_35.png"),
      },
    };
  },
};
</script>

<style lang="scss">
.about-scantop {
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent;
  background-image: url("~@/assets/images/about/scantop_bg.jpg");
  min-height: 50px;

  &-wrap {
    min-height: 50px;
    background-color: rgba(255, 255, 255, 0.9);
  }

  &-inner {
    padding: 70px 15px 50px;

    .img-wrap {
      box-shadow: -12px -12px 0px 0px rgba(65, 107, 159, 1);
    }
    .desc-wrap {
      padding: 20px 10px;

      .sp {
        color: $color-main-aux;
        text-align: justify;
        font-weight: bold;
      }
    }
  }

  table {
    font-size: 14px;
    border: 1px solid $color-main;
    th,
    td {
      padding: 5px 20px;
    }
    th {
      width: auto;
      font-weight: bold;
    }
    thead {
      font-weight: bold;
      font-size: 110%;
    }
    @media (min-width: 992px) {
      th {
        width: 300px;
      }
    }
  }
}
</style>